import { memo } from 'react'

const MycleAppLogo = ({ width, height }: { width: string; height: string }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2607_25766)'>
        <path
          d='M32 0H8C3.58172 0 0 3.58172 0 8V32C0 36.4183 3.58172 40 8 40H32C36.4183 40 40 36.4183 40 32V8C40 3.58172 36.4183 0 32 0Z'
          fill='white'
        />
        <path
          d='M33.7508 17.3133C32.7842 16.5173 31.5785 16.051 30.3275 15.9879L27.9762 10.4648C27.9762 10.4648 27.313 8.91992 25.7003 8.91992H14.3C12.6872 8.91992 12.024 10.4648 12.024 10.4648L9.67276 15.9879C8.42175 16.051 7.21691 16.5173 6.24946 17.3133C4.63955 18.6378 3.74369 20.8082 4.06586 22.8825C4.41535 25.1311 6.11663 27.277 8.36335 27.8479C8.58661 28.6599 9.01994 29.3768 9.63225 29.9298C9.76602 30.0503 9.90732 30.1624 10.0543 30.2661C10.5827 30.6353 11.1913 30.8859 11.8262 31.0027C12.5214 31.1308 13.2524 31.1007 13.9335 30.9066C14.5477 30.7314 15.1233 30.4224 15.6028 29.9995C16.1925 29.4795 16.6164 28.8163 16.8622 28.0457H23.1389C23.3848 28.8163 23.8087 29.4795 24.3984 29.9995C24.8779 30.4224 25.4525 30.7314 26.0676 30.9066C26.7478 31.1007 27.4788 31.1308 28.1749 31.0027C28.8089 30.8859 29.4175 30.6363 29.9469 30.2661C30.0948 30.1624 30.2351 30.0503 30.3689 29.9298C30.9822 29.3768 31.4155 28.6599 31.6378 27.8479C33.8845 27.2761 35.5858 25.1302 35.9353 22.8825C36.2575 20.8082 35.3616 18.6378 33.7517 17.3133H33.7508Z'
          fill='#00AFFF'
        />
        <path
          d='M27.4447 23.2519C27.3392 23.9848 26.7552 24.5688 26.0223 24.6734C25.9403 24.6847 25.8574 24.6913 25.7764 24.6913C25.0812 24.6913 24.4661 24.273 24.2089 23.6249L22.8232 20.0029L21.6089 23.3734C21.3913 24.078 20.7432 24.5547 19.9999 24.5547C19.2567 24.5547 18.6095 24.078 18.3891 23.3696L17.1607 20.0029L15.792 23.6221C15.5348 24.273 14.9196 24.6913 14.2235 24.6913C14.1764 24.6913 14.1293 24.6894 14.0812 24.6856C13.2692 24.6188 12.6079 23.9556 12.5429 23.1436C12.5203 22.8666 12.5637 22.5972 12.672 22.3438L15.6214 14.5458C15.8786 13.8958 16.4938 13.4766 17.1899 13.4766C17.9332 13.4766 18.5803 13.9532 18.8008 14.6616L19.9905 17.9229L21.1662 14.6579C21.3838 13.9532 22.0319 13.4766 22.7751 13.4766C23.4703 13.4766 24.0855 13.8948 24.3427 14.5429L27.3298 22.3476C27.4494 22.6273 27.4899 22.942 27.4457 23.2528L27.4447 23.2519Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_2607_25766'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(MycleAppLogo)
